// useTheme — alterna light/dark escrevendo data-theme no <html>.
// Preferência fica em localStorage ("bu-theme"). Default = sistema.

import { useCallback, useEffect, useState } from "react";

type Theme = "light" | "dark" | null;

const STORAGE_KEY = "bu-theme";

function readStored(): Theme {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return v === "light" || v === "dark" ? v : null;
  } catch {
    return null;
  }
}

function writeStored(t: Theme) {
  try {
    if (t) localStorage.setItem(STORAGE_KEY, t);
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    // sandbox: tudo bem, só não persiste
  }
}

function apply(theme: Theme) {
  const el = document.documentElement;
  if (theme) el.setAttribute("data-theme", theme);
  else el.removeAttribute("data-theme");
}

export function useTheme() {
  const [theme, setThemeState] = useState<Theme>(() => readStored());

  useEffect(() => {
    apply(theme);
  }, [theme]);

  const setTheme = useCallback((t: Theme) => {
    writeStored(t);
    setThemeState(t);
  }, []);

  const toggle = useCallback(() => {
    const cur = document.documentElement.getAttribute("data-theme");
    const sysDark = matchMedia("(prefers-color-scheme: dark)").matches;
    const next: Theme = cur === "dark" ? "light" : cur === "light" ? (sysDark ? "light" : "dark") : sysDark ? "light" : "dark";
    writeStored(next);
    setThemeState(next);
  }, []);

  return { theme, setTheme, toggle } as const;
}
